import {Contacto,} from '../contacto.model';
import {BaseModel} from '../../../shared/models/base-model.model';

export const ingenieroAgronomolabel = 'Ing.Agr.';

export class IngenieroAgronomoCore extends BaseModel{
  ingenieroAgronomoId: string;
  contacto: Contacto;
  cjppu: string;
  regionalId: string;
}
